import { render, staticRenderFns } from "./EditFrameSelectionsModal.vue?vue&type=template&id=5cfbf69d&scoped=true"
import script from "./EditFrameSelectionsModal.vue?vue&type=script&lang=js"
export * from "./EditFrameSelectionsModal.vue?vue&type=script&lang=js"
import style0 from "./EditFrameSelectionsModal.vue?vue&type=style&index=0&id=5cfbf69d&prod&lang=scss&scoped=true"
import style1 from "./EditFrameSelectionsModal.vue?vue&type=style&index=1&id=5cfbf69d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cfbf69d",
  null
  
)

export default component.exports